import { store } from 'careand-redux/store';
import { getUnwrappedDispatch } from 'careand-redux/useAppDispatch';
import { ActionExecutor } from './ActionExecutor';

/**
 * Watches for new "ready" actions in Redux state and automatically executes them.
 * This runs globally and listens to all action state changes.
 */
export function initializeActionExecutionWatcher() {
  let lastReadyActionIds = new Set<string>();

  store.subscribe(() => {
    const state = store.getState();
    const readyActions = Object.values(state.actions.byId).filter((it) => it.status === 'ready');
    const currentReadyIds = new Set(readyActions.map((a) => a.id));

    // Find new ready actions
    const newReadyActions = readyActions.filter((action) => !lastReadyActionIds.has(action.id));

    lastReadyActionIds = currentReadyIds;

    // Execute new ready actions
    if (newReadyActions.length > 0) {
      const dispatch = getUnwrappedDispatch(store.dispatch);
      const executor = new ActionExecutor(dispatch);
      newReadyActions.forEach((action) => executor.execute(action));
    }
  });
}
